import * as ng from 'angular';

ng.module('e360')
   .filter('authenticatedUrl', authenticatedUrlFilter);

authenticatedUrlFilter.$inject = ['session'];
export function authenticatedUrlFilter(session) {
   return function authenticatedUrl(url:string):string {
      let sep = url.indexOf('?') !== -1 ? '&' : '?';
      return `${url}${sep}access_token=${session.getToken()}`;
   }
}
